import { Redirect, Route } from 'react-router-dom';
import { ProductType } from '@tink/core/src/types';
import {
  ProductDimensionAccountCheck,
  ProductDimensionAuthorize,
  ProductDimensionIncomeCheck,
  ProductDimensionPay,
} from '../../../models/product';
import { buildHomeUrl, buildRedirectProviderRoute } from '../../../routes';

export const LegacyRouter = () => {
  return (
    <>
      <Route
        path="/:version/pay"
        render={({
          match: {
            params: { version },
          },
        }) => (
          <Redirect
            to={buildHomeUrl({
              version,
              productType: ProductType.PAY,
              productDimension: ProductDimensionPay.DIRECT,
            })}
          />
        )}
      />
      <Route
        path="/:version/authorize"
        render={({
          match: {
            params: { version },
          },
        }) => (
          <Redirect
            to={buildHomeUrl({
              version,
              productType: ProductType.AUTHORIZE,
              productDimension: ProductDimensionAuthorize.CONNECT,
            })}
          />
        )}
      />
      <Route
        path="/:version/income-check"
        render={({
          match: {
            params: { version },
          },
        }) => (
          <Redirect
            to={buildHomeUrl({
              version,
              productType: ProductType.INCOME_CHECK,
              productDimension: ProductDimensionIncomeCheck.CREATE_REPORT,
            })}
          />
        )}
      />
      <Route
        exact
        path="/:version/account-check/connect/:providerName"
        render={({
          match: {
            params: { version, providerName },
          },
        }) => (
          <Redirect
            to={buildRedirectProviderRoute({
              version,
              productType: ProductType.ACCOUNT_CHECK,
              productDimension: ProductDimensionAccountCheck.CREATE_REPORT,
              providerName,
            })}
          />
        )}
      />
      <Route
        exact
        path={['/:version/account-check/connect', '/:version/account-check']}
        render={({
          match: {
            params: { version },
          },
        }) => (
          <Redirect
            to={buildHomeUrl({
              version,
              productType: ProductType.ACCOUNT_CHECK,
              productDimension: ProductDimensionAccountCheck.CREATE_REPORT,
            })}
          />
        )}
      />
    </>
  );
};
